<!-- Spinner -->
<prgov-spinner [loading]="!dynamicFormService.isLoadingForm && !moduleLoadError" [overlayOpacity]="true" [bgLight]="true"></prgov-spinner>

<!-- Error de carga del módulo -->
<div *ngIf="moduleLoadError" class="d-flex flex-column align-items-center justify-content-center p-4">
  <div class="alert alert-danger text-center" style="max-width: 500px;">
    <div class="d-flex align-items-center justify-content-center mb-3">
      <mat-icon class="mr-2" color="warn">error</mat-icon>
      <h4 class="mb-0">{{ 'componentLoader.errorTitle' | translate }}</h4>
    </div>
    <p class="mb-3">
      No se pudo cargar el formulario para este requisito. Esto puede deberse a que:
    </p>
    <ul class="text-left">
      <li>El requisito no tiene un formulario asociado</li>
      <li>Hay un problema temporal con el servidor</li>
      <li>El módulo del formulario no está disponible</li>
    </ul>
    <div class="mt-3">
      <button mat-stroked-button color="primary" (click)="close()" class="mr-2">
        {{ 'close' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="retryLoadModule()">
        {{ 'componentLoader.retry' | translate }}
      </button>
    </div>
  </div>
</div>
<div *ngIf="dynamicFormService.requirement?.IsFlagedForVerification && 
            transactionService.itemToEdit.CreatedByCurrentUser" class="revision-message-display">
  <div class="alert-disp">
    <div class="my-1">
      <div class="row">
        <div class="col col-sm-12 col-md-12 col-lg-12">
          <div class="ml-2 d-flex align-items-center justify-content-stretch">
            <mat-icon class="mr-2" color="primary">error</mat-icon>
            <span class="h6 mt-2 mr-1">
              <strong>
                {{ 'componentLoader.revisionComment' | translate }}
              </strong>
            </span>
            <button *ngIf="!minimize" mat-stroked-button class="btn-display" (click)="minimizeRevisionAlert(true)">
              {{ 'componentLoader.view-less' | translate }}
              <mat-icon class="icon-display ml-auto">expand_less</mat-icon>
            </button>
            <button *ngIf="minimize" mat-stroked-button class="btn-display" (click)="minimizeRevisionAlert(false)">
              {{ 'componentLoader.view-more' | translate }}
              <mat-icon class="custom-icon-chevron ml-auto">expand_more</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <ng-container *ngIf="!minimize">
        <div class="row ml-2 mt-4">
          <div class="col col-sm-12 col-md-12 col-lg-12">
            <div class="h5 ml-3" [innerHtml]="dynamicFormService.requirement.Comment | keepHtml">
            </div>
          </div>
        </div>
        <div class="row ml-2 mt-2">
          <div class="col col-sm-12 col-md-12 col-lg-12">
            <div class="d-flex align-items-start ml-2">
              <button class="pull-left btn-s-rev d-flex align-items-stretch justify-content-center spinner-wht"
                mat-stroked-button color="primary" (click)="trySubmitForReview()"
                [class.spinner-white]="this.isSaving()">
                <ng-container *ngIf="!isSaving()">
                  {{ 'componentLoader.submitChangesForReview' | translate }}
                </ng-container>
                <ng-container *ngIf="isSaving() && saving.action=='submit-for-review'"
                  class="d-flex align-items-center spinner-wht justify-content-center">
                  <mat-spinner [diameter]="20" class="mat-spinner-color"></mat-spinner>
                </ng-container>
                <mat-icon *ngIf="!isSaving()" class="mb-1">send</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<div [hidden]="dynamicFormService.isLoadingForm" class="bg-w-wht-100">
  <div style="padding-bottom: 20px" 
    [ngClass]="dynamicFormService.revisionMode ? 'flex-row custom-space-between form-header-revision-format' : 'flex-row custom-space-between form-header-format'">
    <div class="d-n-i pr-4 mt-1">
      <a (click)="close()">
        <mat-icon>clear</mat-icon>
      </a>
    </div>
    <div class="d-flex align-items-center mt-2">
      <h2 class="m-1" [innerHTML]="dynamicFormService.requirement?.FormName | ml:multiLanguageService.retrigger"></h2>
    </div>
    <div class="d-n mt-2">
      <div class="d-flex align-items-center justify-content-center">
        <button mat-stroked-button (click)="close()" class="btn-hgt pr-3 mr-5">
          {{ 'close' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div [ngClass]="dynamicFormService.revisionMode ? 'revision-mode-spacer' : 'header-spacer'">
  </div>
  <ng-container [appModuleLoad]="dynamicFormService.formName">
  </ng-container>
</div>